import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import React from 'react';
import useSetHtmlHeader from '../../hooks/useSetHtmlHeader';
import './index.scss';

export default function BackCloseBarComponent(props) {
  const {
    isBack = false,
    onClick
  } = props;

  const navigate = useNavigate();

  const htmlHeader = useSetHtmlHeader({ themeColor: '#e53323' });

  const backNav = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }

  };

  return (
    <div className={ isBack ? "red-block header" : "red-block header end-header" }>
      {
        isBack &&
        <Button
          size='middle'
          onClick={backNav}
          startIcon={<KeyboardArrowLeftIcon />}>
          Back
        </Button>
      }

      {
        !isBack &&
        <CloseIcon
          className="icon"
          size="large"
          onClick={backNav}
        />
      }

    </div>
  );
}